import styled from "styled-components";

export const KryjkiWrapper = styled.div`
    max-width: 1280px;
    width: 100%;
    margin: 60px auto 40px;
    padding: 0 var(--container-pad);

    @media (max-width: 600px) {
        margin-top: 40px;
    }
`;
